import getErrorMessage from "../../../util";
import httpCommon from "../../../http-common";
import { PO_Backlog_Service } from "../../../redux/po_backlog/po_backlog.services";
import axiosInstance from "../../../http-common";
import dayjs from "dayjs";

// const get_date_object_from_dd_mm_yy_hh_min = (time_string) => {
//   const [date, time] = time_string.split(" ");
//   const [dd, mm, yy] = date.split("/");
//   const [hh, min] = time.split(":");
//   const parsed_time = new Date(2000 + (+yy), mm - 1, dd, hh, min);
//   return parsed_time;
// };

// const backend_url = process.env.REACT_APP_BACKEND_MAIN_URL;

export const get_schedule = async () => {
  // console.log(scheduleStatus);

  try {
    const result = await axiosInstance.get(`/v1/qc/check_schedule_status/`);
    // console.log({ sttaus: result });
    let scheduleStatus;
    if (result.data) {
      scheduleStatus = result?.data?.message;
    }
    // console.log("scheduleStatus", scheduleStatus);
    if (scheduleStatus === "approved") {
      const response = await axiosInstance.get(`/v1/qc/approve_schedule/`);
      const data = response.data;
      // console.log(data);
      if (data.status === "success") {
        const schedule = data?.["approved_qc_schedule"].map((item) => {
          // const start_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
          // const end_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
          const machine_start_time = new Date(item.machine_start_time);
          const machine_end_time = new Date(item.machine_end_time);
          const pre_start_time = new Date(item.pre_start_time);
          return {
            ...item,
            id: item._id,
            remark: item.remark === "done" ? "Completed" : item.remark,
            machine_start_time,
            machine_end_time,
            pre_start_time,
            // status: item.status === "finished" ?
          };
        });
        data.qc_schedule = schedule;
        // console.log(data);
        return data;
      }
    } else if (scheduleStatus === "saved") {
      const response = await axiosInstance.get(`/v1/qc/save_schedule/`);
      const data = response.data;
      console.log(data);
      if (data.status === "success") {
        const schedule = data?.["saved_qc_schedule"]?.map((item) => {
          // const start_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
          // const end_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
          const machine_start_time = new Date(item.machine_start_time);
          const machine_end_time = new Date(item.machine_end_time);
          const pre_start_time = new Date(item.pre_start_time);
          return {
            ...item,
            id: item._id,
            remark: item.remark === "done" ? "Completed" : item.remark,
            machine_start_time,
            machine_end_time,
            pre_start_time,
            // status: item.status === "finished" ?
          };
        });
        data.qc_schedule = schedule;
        return data;
      }
    } else if (scheduleStatus === "current" || scheduleStatus === "generated") {
      const response = await httpCommon.get(`/v1/qc/get_qc_schedule/`);
      const data = response.data;
      console.log(data);
      if (data.status === "success") {
        const schedule = data?.qc_schedule.map((item) => {
          // const start_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
          // const end_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
          const machine_start_time = new Date(item.machine_start_time);
          const machine_end_time = new Date(item.machine_end_time);
          const pre_start_time = new Date(item.pre_start_time);
          return {
            ...item,
            id: item._id,
            remark: item.remark === "done" ? "Completed" : item.remark,
            machine_start_time,
            machine_end_time,
            pre_start_time,
            // status: item.status === "finished" ?
          };
        });
        data.qc_schedule = schedule;
        return data;
      }
    }
  } catch (error) {
    const error_message = getErrorMessage(error);
    // console.log({ error_message });
    return { status: "failure", error_message };
  }
};

export const get_ongoing_schedule = async () => {
  try {
    const response = await httpCommon.get(`/v1/qc/get_ongoing_schedule/`);
    const data = response.data;
    console.log(data);
    if (data.length >= 0) {
      const schedule = data.map((item) => {
        // const start_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
        // const end_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
        const machine_start_time = new Date(item.machine_start_time);
        const machine_end_time = new Date(item.machine_end_time);
        const pre_start_time = new Date(item.pre_start_time);
        return {
          ...item,
          id: item._id,
          remark: item.remark === "done" ? "Completed" : item.remark,
          machine_start_time,
          machine_end_time,
          pre_start_time,
          // status: item.status === "finished" ?
        };
      });
      return { ongoing_schedule: schedule };
    }
    return { status: "failure" };
  } catch (error) {
    const error_message = getErrorMessage(error);
    // console.log({ error_message });
    return { status: "failure", error_message };
  }
};

export const get_adhoc_schedule = async () => {
  try {
    const response = await httpCommon.get(`/v1/qc/adhoc_schedule/`);
    const data = response.data?.["adhoc_qc_schedule"];
    console.log(data);
    if (data.length >= 0) {
      const schedule = data.map((item) => {
        // const start_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
        // const end_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
        const machine_start_time = new Date(item.machine_start_time);
        const machine_end_time = new Date(item.machine_end_time);
        const pre_start_time = new Date(item.pre_start_time);
        return {
          ...item,
          id: item._id,
          remark: item.remark === "done" ? "Completed" : item.remark,
          machine_start_time,
          machine_end_time,
          pre_start_time,
          // status: item.status === "finished" ?
        };
      });
      return { adhoc_schedule: schedule };
    }
    return { status: "failure" };
  } catch (error) {
    const error_message = getErrorMessage(error);
    // console.log({ error_message });
    return { status: "failure", error_message };
  }
};
export const get_completed_schedule = async () => {
  try {
    const response = await httpCommon.get(`/v1/qc/completed_schedule/`);
    console.log(response);
    const data = response.data?.["completed_schedules"];
    console.log(data);
    if (data.length >= 0) {
      const schedule = data.map((item) => {
        // const start_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
        // const end_time = get_date_object_from_dd_mm_yy_hh_min(item.start_time);
        const machine_start_time = new Date(item.machine_start_time);
        const machine_end_time = new Date(item.machine_end_time);
        const pre_start_time = new Date(item.pre_start_time);
        return {
          ...item,
          id: item._id,
          remark: item.remark === "done" ? "Completed" : item.remark,
          machine_start_time,
          machine_end_time,
          pre_start_time,
          // status: item.status === "finished" ?
        };
      });
      return { completed_schedule: schedule };
    }
    return { status: "failure" };
  } catch (error) {
    const error_message = getErrorMessage(error);
    // console.log({ error_message });
    return { status: "failure", error_message };
  }
};

export const get_material_types_list = async () => {
  const response_sample_types = await PO_Backlog_Service.sample_types_get();
  const result_sample_types = response_sample_types.data;
  if (result_sample_types.data && Array.isArray(result_sample_types.data)) {
    // console.log(response_sample_types.data);
    const sample_types = result_sample_types.data;
    return sample_types;
  } else if (
    result_sample_types.data &&
    typeof result_sample_types.data === "object"
  ) {
    const sample_types = Object.values(result_sample_types.data).reduce(
      (acc, el) => [...acc, ...el],
      []
    );
    return sample_types;
  }
};

// to get status of schedule
export const getScheduleStatus = async (setData, setLoading) => {
  setLoading(true);
  try {
    const result = await axiosInstance.get(`/v1/qc/check_schedule_status/`);
    // console.log({ sttaus: result });
    if (result.data) {
      const data = result?.data?.message;
      if (
        result["data"]?.["message"] &&
        setData &&
        typeof setData === "function"
      ) {
        setData(data);
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

// to save schedule
export const updateSchedule = async (data) => {
  try {
    const result = await axiosInstance.post(`/v1/qc/save_schedule/`, data);
    console.log(result);
  } catch (error) {
    console.log(error);
  }
};

// to post approved schedulw
export const setApproveSchedule = async (data) => {
  try {
    const result = await axiosInstance.post(`/v1/qc/approve_schedule/`, data);
    console.log(result);
  } catch (error) {
    console.log(error);
  }
};

// function to merge maps
export const mergeMapsToArray = (map2, map3) => {
  const resultArray = [];
  const formatDate = (date) => {
    if (date instanceof Date) {
      const formattedDate = dayjs(date).format("YYYY-MM-DD HH:mm:ss");
      return formattedDate;
    } else {
      // Hwhen the input is not a valid Date object
      console.error("Invalid Date object");
      return null;
    }
  };

  // if (map1.size > 0) {
  //   resultArray.push(
  //     ...Array.from(map1.values()).map((obj) => ({
  //       ...obj,
  //       machine_end_time: formatDate(obj.machine_end_time),
  //       machine_start_time: formatDate(obj.machine_start_time),
  //       pre_start_time: formatDate(obj.pre_start_time),
  //     }))
  //   );
  // }

  if (map2.size > 0) {
    resultArray.push(
      ...Array.from(map2.values()).map((obj) => ({
        ...obj,
        machine_end_time: formatDate(obj.machine_end_time),
        machine_start_time: formatDate(obj.machine_start_time),
        pre_start_time: formatDate(obj.pre_start_time),
      }))
    );
  }

  if (map3.size > 0) {
    resultArray.push(
      ...Array.from(map3.values()).map((obj) => ({
        ...obj,
        machine_end_time: formatDate(obj.machine_end_time),
        machine_start_time: formatDate(obj.machine_start_time),
        pre_start_time: formatDate(obj.pre_start_time),
      }))
    );
  }
  return resultArray;
};
